interface RoundedTabLabelProps {
  roundChildren: React.ReactNode
  children: React.ReactNode
  done?: boolean
  disabled?: boolean
}

export const RoundedTabLabel = ({
  roundChildren,
  children,
  done = false,
  disabled = false,
}: RoundedTabLabelProps) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <span
      style={{
        borderRadius: '100%',
        background: disabled || done ? '#F0F0F0' : '#7F45E5',
        width: '32px',
        height: '32px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: disabled ? '#848484' : done ? '#7F45E5' : '#fff',
      }}
    >
      {roundChildren}
    </span>
    <span style={{ color: disabled ? '#848484' : '#000' }}>{children}</span>
  </div>
)
